export default {
  transactionsFilter: {
    filters: "الفلاتر",
    applyFilter: "تطبيق الفلتر",
    depositFilterForm: {
      cryptoCurrency: "العملة المشفرة",
      currencyName: "اسم العملة",
      ofDate: "من تاريخ",
      tillDate: "إلى تاريخ",
      status: "الحالة"
    },
    exchangeFilterForm: {
      fromCurrency: "من العملة المشفرة",
      currencyName: "اسم العملة",
      toCryptoCurrency: "إلى العملة المشفرة",
      ofDate: "من تاريخ",
      tillDate: "إلى تاريخ",
      status: "الحالة"
    },
    filterForm: {
      time: "الوقت",
      defaultDate: {
        week: "الأسبوع الماضي",
        month: "الشهر الماضي",
        threeMonth: "الثلاثة أشهر الماضية"
      },
      fromDate: "من تاريخ",
      tillDate: "إلى تاريخ",
      status: "الحالة",
      currencyFilterInput: {
        cryptoCurrency: "العملة المشفرة",
        currencyName: "اسم العملة",
        searchCryptoPlaceholder: "ابحث عن اسم العملة المشفرة أو الرمز",
        noCrypto: "لم يتم العثور على عملة"
      },
      fromToCurrenciesInput: {
        fromCryptoCurrency: "من العملة المشفرة",
        currencyName: "اسم العملة",
        toCryptoCurrency: "إلى العملة المشفرة",
        searchInputPlaceholder: "ابحث عن اسم العملة المشفرة أو الرمز",
        noCrypto: "لم يتم العثور على عملة"
      },
      withdrawFilterForm: {
        cryptoCurrency: "العملة المشفرة",
        currencyName: "اسم العملة",
        fromDate: "من تاريخ",
        tillDate: "إلى تاريخ",
        status: "الحالة"
      },
      submitButton: "تأكيد"
    }
  },
  transactionDetail: {
    rialDeposit: "إيداع الريال",
    rialWithdrawal: "سحب الريال",
    transactionDetails: "تفاصيل المعاملة",
    depositCryptoDetail: {
      amount: "المبلغ المودع",
      transactionId: "معرف المعاملة",
      date: "التاريخ والوقت",
      txid: "معرف المعاملة (TXID)"
    },
    batchNumber: "رقم الدفعة",
    voucherNumber: "القسيمة",
    voucherCode: "كود التفعيل",
    voucherAmount: "المبلغ",
    depositRialDetail: {
      amount: "المبلغ المودع",
      transactionId: "معرف المعاملة",
      type: "النوع",
      online: "عبر الإنترنت",
      offline: "غير متصل",
      date: "التاريخ والوقت",
      paymentInformation: "معلومات الدفع",
      from: "بوابة الدفع",
      trackingNumber: "كود التتبع",
      cardNumber: "رقم البطاقة",
      fromBank: "البنك المصدر",
      depositSystem: "نوع الإيداع"
    },
    exchangeDetail: {
      pay: "الدفع",
      receive: "الاستلام",
      status: "الحالة",
      transactionId: "معرف المعاملة",
      date: "التاريخ والوقت",
      fee: "الرسوم"
    },
    offlinePaymentDetail: {
      amount: "المبلغ المودع",
      date: "التاريخ والوقت",
      fromBank: "البنك المصدر",
      depositSystem: "نوع الإيداع",
      trackingNumber: "كود التتبع"
    },
    transferDetail: {
      transferred: "تم التحويل",
      transactionId: "معرف المعاملة",
      date: "التاريخ والوقت",
      description: "الوصف"
    },
    withdrawCryptoDetail: {
      amount: "المبلغ المستلم الصافي",
      transactionId: "معرف المعاملة",
      date: "التاريخ والوقت",
      fee: "الرسوم",
      grossAmount: "المبلغ الإجمالي (بما في ذلك الرسوم)",
      address: "عنوان المحفظة المستهدفة",
      txid: "معرف المعاملة (TXID)",
      seeInDesc: "انظر في الوصف",
      description: "الوصف"
    },
    withdrawRialDetail: {
      amount: "المبلغ المسحوب",
      transactionId: "معرف المعاملة",
      date: "التاريخ والوقت",
      shebaNumber: "رقم IBAN",
      trackingNumber: "كود التتبع",
      seeInDesc: "انظر في الوصف",
      description: "الوصف"
    },
    cardNumber: "رقم البطاقة",
    datailsTitle: "الوصف"
  },
  depositTable: {
    filters: "الفلاتر",
    clearAllFilters: "مسح الفلاتر",
    all: "الكل",
    offline: "غير متصل",
    online: "عبر الإنترنت",
    to: "إلى",
    from: "من",
    transactionId: "معرف المعاملة",
    depositAmount: "المبلغ المودع",
    date: "الوقت",
    time: "الوقت",
    type: "النوع",
    status: "الحالة",
    action: "الإجراء",
    crypto: "العملة المشفرة",
    amount: "المبلغ"
  },
  detailsInTable: {
    details: "التفاصيل"
  },
  exchangeTable: {
    filters: "الفلاتر",
    clearAllFilters: "مسح الفلاتر",
    all: "الكل",
    from: "من",
    to: "إلى",
    transactionId: "معرف المعاملة",
    payment: "الدفع",
    toCurrency: "إلى",
    executed: "تم التنفيذ",
    date: "الوقت",
    time: "الوقت",
    status: "الحالة",
    action: "الإجراء"
  },
  transferTable: {
    filters: "الفلاتر",
    clearAllFilters: "مسح الفلاتر",
    all: "الكل",
    from: "من",
    to: "إلى",
    crypto: "العملة المشفرة",
    amount: "المبلغ",
    transactionId: "معرف المعاملة",
    date: "الوقت",
    time: "الوقت",
    status: "الحالة",
    action: "الإجراء"
  },
  verifyInTable: {
    pay: "اذهب إلى بوابة الدفع",
    completeOrder: "إكمال الطلب",
    smsConfirmation: "تأكيد الهوية"
  },
  withdrawalTable: {
    filters: "الفلاتر",
    clearAllFilters: "مسح الفلاتر",
    all: "الكل",
    from: "من",
    to: "إلى",
    transactionId: "معرف المعاملة",
    withdrawalAmount: "المبلغ المسحوب",
    date: "الوقت",
    time: "الوقت",
    status: "الحالة",
    action: "الإجراء",
    crypto: "العملة المشفرة",
    amount: "المبلغ"
  },
  categories: [
    { to: "deposits", tooltip: "الإيداعات" },
    { to: "withdrawals", tooltip: "السحوبات" },
    { to: "exchanges", tooltip: "التبادلات" },
    { to: "transfers", tooltip: "التحويلات" }
  ]
};
